import React from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Locations from '../components/Locations';
import Review from '../components/Review';
import Services from '../components/Services';
const Home = () => {
    return (
        <>
            <Hero />
            <Locations />
            <Review/>
            <Intro />
            <Services />
            <Clients />
            <Footer />
        </>

    )
}

export default Home;

